import helpers from "../utils/helpers";

function cfRecaptchaCallback() {
  grecaptcha.render("recaptcha", {
    sitekey: recaptcha_v2_key,
  });
}

window.onloadCallback = cfRecaptchaCallback;

const TemplateContacts = {
  init() {
    this.events();
  },

  events() {
    $("#contact_form").on("submit", (e) => {
      e.preventDefault();

      const formEl = $(e.currentTarget);

      if (!formEl.find("[name=cf_policy]").prop("checked")) {
        alert("Please check the policy.");
        return;
      }

      let token = grecaptcha.getResponse();
      // if (!token) {
      //   alert("Please check the captcha.");
      //   return;
      // }
      if (helpers.validate(formEl)) {
        TemplateContacts.submitCform(token);
      }
    });

    let file_input = $("#cf_file");
    let remove_file = $("#remove_file");
    file_input.on("change", function () {
      if (file_input.val() !== "") {
        remove_file.addClass("active");
      } else {
        remove_file.removeClass("active");
      }
    });

    $(".file-remove-btn").on("click", function () {
      file_input.val("");
      remove_file.removeClass("active");
    });

    let select = $("#cf_subject");
    select.on("change", function () {
      if (select.val() === "complaint") {
        $("#complaint_fields").removeClass("hidden");
        $("[name=cf_product]").prop("required", true);
      } else {
        $("#complaint_fields").addClass("hidden");
        $("[name=cf_product]").prop("required", false);
      }
    });
  },

  submitCform: function (token) {
    grecaptcha.reset();

    let form = $("#contact_form");
    let formData = new FormData(form[0]);
    formData.append("action", "submit_contact_cform");
    formData.append("token", token);

    $.ajax({
      url: ajaxurl,
      type: "POST",
      processData: false,
      contentType: false,
      data: formData,
      beforeSend() {
        form.addClass("loading");
        form.find(".form-status").addClass("hidden");
      },
      success: function (response) {
        form.removeClass("loading");

        if (response.success) {
          form[0].reset();
        }

        $("#form-message .popup-body")
          .html(response.data.popup)
          .closest(".popup")
          .addClass("active");
      },
    });
  },
};

export default TemplateContacts;
